import { gql } from '@apollo/client';

const UPCOMING_HOLIDAYS = gql`
  query UpcomingHolidays($days: Int = 120) {
    upcomingHolidays(days: $days) {
      date
      name
    }
  }
`;

export default UPCOMING_HOLIDAYS;
